// extracted by mini-css-extract-plugin
export var billingAddress = "_xj-g";
export var contactInfo = "_xj-d";
export var customerInfoContainer = "_xj-c";
export var customerInfoContainerMobile = "_xj-h";
export var customerInfoRow = "_xj-a";
export var customerInfoSection = "_xj-b";
export var fullWidthDividerMobile = "_xj-i";
export var imageContainer = "_xj-1";
export var paymentMethod = "_xj-e";
export var priceText = "_xj-6";
export var priceTextMobile = "_xj-7";
export var product = "_xj-0";
export var productImage = "_xj-2";
export var productInfo = "_xj-4";
export var productMobile = "_xj-9";
export var productTitle = "_xj-8";
export var quantityBadge = "_xj-3";
export var quantityText = "_xj-5";
export var shippingAddress = "_xj-f";